import React, { useState } from 'react';
import { FilePlus, Scissors, LayoutGrid } from 'lucide-react';
import Button from '../../ui/Button';
import PDFMerger from './PDFMerger';
import PDFSplitter from './PDFSplitter';
import PDFArranger from './PDFArranger';

const PDFUtilities: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'merge' | 'split' | 'arrange'>('merge');

  return (
    <div className="space-y-6">
      <div className="flex space-x-2">
        <Button
          variant={activeTab === 'merge' ? 'primary' : 'outline'}
          onClick={() => setActiveTab('merge')}
          leftIcon={<FilePlus size={16} />}
        >
          Merge PDFs
        </Button>
        <Button
          variant={activeTab === 'split' ? 'primary' : 'outline'}
          onClick={() => setActiveTab('split')}
          leftIcon={<Scissors size={16} />}
        >
          Split PDF
        </Button>
        <Button
          variant={activeTab === 'arrange' ? 'primary' : 'outline'}
          onClick={() => setActiveTab('arrange')}
          leftIcon={<LayoutGrid size={16} />}
        >
          Arrange Pages
        </Button>
      </div>

      {activeTab === 'merge' && <PDFMerger />}
      {activeTab === 'split' && <PDFSplitter />}
      {activeTab === 'arrange' && <PDFArranger />}
    </div>
  );
};

export default PDFUtilities;